<template>
  <CountrySwitchMenuChipButton
    v-if="variant === 'chip'"
    :countryCode="thisMarket.countryCode"
    trackingSpot="nav"
    @click="isVisible = true"
  />
  <CountrySwitchMenuButton
    v-else
    :countryCode="thisMarket.countryCode"
    :isOpen="isVisible"
    trackingSpot="nav"
    @click="isVisible = true"
  />
  <div
    v-if="isVisible"
    class="bg-surface-default-low fixed inset-0 flex flex-col"
  >
    <div
      class="border-static-default-low flex h-52 items-center border-b px-16 py-8"
    >
      <CountrySwitchMenuHeader
        :is-full-screen="true"
        @click="() => (isVisible = false)"
      />
    </div>
    <CountrySwitchMenuSearchList />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import CountrySwitchMenuButton from './CountrySwitchMenuButton.vue'
import CountrySwitchMenuChipButton from './CountrySwitchMenuChipButton.vue'
import CountrySwitchMenuHeader from './CountrySwitchMenuHeader.vue'
import CountrySwitchMenuSearchList from './CountrySwitchMenuSearchList.vue'

withDefaults(
  defineProps<{
    variant?: 'button' | 'chip'
  }>(),
  {
    variant: 'button',
  },
)

const thisMarket = useMarketplace().market
const isVisible = ref(false)
</script>
